export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6879.e1b28c16.jpg";